import { Box, Button, Typography, useMediaQuery } from '@mui/material';

function KeyFeatures({ setVideoOpened }: { setVideoOpened: (s: boolean) => void }) {
  const isMobile = useMediaQuery('(max-width:800px)');

  return (
    <Box
      id="features_anchor"
      sx={{
        scrollMarginTop: '100px',
        maxWidth: '1350px',
        padding: '0 20px',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        margin: isMobile ? '80px auto' : '160px auto',
      }}
    >
      <Typography
        sx={{
          fontSize: isMobile ? '32px' : '56px',
          fontFamily: 'RedHat700',
          color: '#fff',
          maxWidth: '890px',
          textAlign: 'center',
          lineHeight: 'normal',
        }}
      >
        Key features of platform
      </Typography>
      <Typography
        sx={{
          fontSize: isMobile ? '16px' : '20px',
          fontFamily: 'RedHat400',
          color: '#B5B5B5',
          maxWidth: '660px',
          textAlign: 'center',
          marginTop: isMobile ? '10px' : '20px',
          marginBottom: isMobile ? '40px' : '80px',
          lineHeight: isMobile ? 'normal' : '30px',
        }}
      >
        Leverage AI-powered insights, ad network integrations, and cohort analysis to optimize your marketing
        strategies.
      </Typography>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '20px',
        }}
      >
        <Box
          sx={{
            background: '#E4F1FF',
            borderRadius: '32px',
            overflow: 'hidden',
            display: 'flex',
            gap: '20px',
            flexDirection: isMobile ? 'column' : 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Box
            sx={{
              minWidth: isMobile ? '100%' : '380px',
              maxWidth: '560px',
              marginLeft: isMobile ? '0px' : '50px',
            }}
          >
            <Typography
              sx={{
                fontSize: isMobile ? '20px' : '40px',
                fontFamily: 'RedHat700',
                color: '#171717',
                marginBottom: '15px',
                lineHeight: 'normal',
                margin: isMobile ? '40px 20px 15px' : undefined,
              }}
            >
              Every click. Every dollar. Every insight.
            </Typography>
            <Typography
              sx={{
                fontSize: isMobile ? '16px' : '20px',
                fontFamily: 'RedHat400',
                color: '#171717',
                lineHeight: isMobile ? 'normal' : '30px',
                margin: isMobile ? '0 20px 30px' : undefined,
              }}
            >
              Transform interactions into actionable insights. Optimize ad spend, understand user behavior, and make
              data-driven decisions to maximize ROI and drive growth.
            </Typography>
            <Box
              sx={{
                height: '1px',
                background: '#C8DAED',
                margin: isMobile ? '30px 20px' : '40px 0',
              }}
            ></Box>
            <Typography
              sx={{
                fontSize: isMobile ? '20px' : '24px',
                fontFamily: 'RedHat700',
                color: '#171717',
                lineHeight: 'normal',
                margin: isMobile ? '0 20px' : undefined,
              }}
            >
              Want to see how it works?
            </Typography>
            <Typography
              sx={{
                fontSize: isMobile ? '16px' : '20px',
                fontFamily: 'RedHat400',
                color: '#171717',
                lineHeight: isMobile ? 'normal' : '30px',
                margin: isMobile ? '0 20px 20px' : '0 0 20px',
              }}
            >
              Watch a short video about the platform's advantages now!
            </Typography>
            <Box
              sx={{
                padding: isMobile ? '0 20px' : undefined,
              }}
            >
              <Button
                onClick={() => {
                  setVideoOpened(true);
                }}
                variant="contained"
                sx={{
                  backgroundColor: '#FFF',
                  borderRadius: '12px',
                  padding: isMobile ? '15px 30px' : '20px 40px',
                  fontSize: isMobile ? '16px' : '20px',
                  fontFamily: 'RedHat800',
                  color: '#171717',
                  boxShadow: 'none',
                  textTransform: 'initial',
                  display: 'flex',
                  gap: '10px',
                  height: isMobile ? '52px' : '66px',
                  lineHeight: 'normal',
                  width: isMobile ? '100%' : undefined,
                  '&:hover': {
                    boxShadow: 'none',
                  },
                }}
              >
                <img src="/images/play.svg" alt="play"></img>
                See the Platform in Action
              </Button>
            </Box>
          </Box>
          <img
            style={{
              maxWidth: '100%',
            }}
            width={660}
            src={isMobile ? '/images/man_mob.webp' : '/images/man.webp'}
            alt="data storage"
          ></img>
        </Box>
        <Box
          sx={{
            background: '#247BFE',
            borderRadius: '32px',
            overflow: 'hidden',
            display: 'flex',
            gap: '20px',
            flexDirection: isMobile ? 'column' : 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Box
            sx={{
              minWidth: isMobile ? '100%' : '360px',
              maxWidth: '560px',
              marginLeft: isMobile ? '0px' : '50px',
            }}
          >
            <Typography
              sx={{
                fontSize: isMobile ? '20px' : '40px',
                fontFamily: 'RedHat700',
                color: '#FFF',
                marginBottom: '15px',
                lineHeight: 'normal',
                margin: isMobile ? '40px 20px 15px' : undefined,
              }}
            >
              Large-Scale User <br />
              Data Storage
            </Typography>
            <Typography
              sx={{
                fontSize: isMobile ? '16px' : '20px',
                fontFamily: 'RedHat400',
                color: '#FFF',
                lineHeight: isMobile ? 'normal' : '30px',
                margin: isMobile ? '0 20px 30px' : undefined,
              }}
            >
              The platform provides secure, scalable storage for vast amounts of user data, ensuring high performance
              even with significant data volumes.
            </Typography>
          </Box>
          <img
            style={{
              maxWidth: '100%',
            }}
            width={660}
            src={isMobile ? '/images/storage_mob.webp' : '/images/storage.webp'}
            alt="data storage"
          ></img>
        </Box>
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            gap: '30px',
            minHeight: '900px',
            '& .title': {
              fontSize: isMobile ? '20px' : '24px',
              fontFamily: 'RedHat700',
              color: '#FFF',
              lineHeight: 'normal',
              margin: isMobile ? '40px 20px 0' : '50px 50px 0',
            },
            '& .subTitle': {
              fontSize: isMobile ? '16px' : '20px',
              fontFamily: 'RedHat400',
              color: '#B5B5B5',
              lineHeight: isMobile ? 'normal' : '30px',
              margin: isMobile ? '15px 20px 30px' : '15px 50px 50px',
            },
            '& .black': {
              color: '#171717',
            },
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
              gap: '30px',
            }}
          >
            <Box
              sx={{
                flexGrow: 1,
                borderRadius: '32px',
                overflow: 'hidden',
                background: '#28292B',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
              }}
            >
              <Box>
                <Typography className="title">LTV Predictions</Typography>
                <Typography className="subTitle">
                  By leveraging an AI-trained model, the system predicts the lifetime value (LTV) of users, helping
                  businesses to focus their efforts on high-value customers and optimize their marketing spend
                  accordingly.
                </Typography>
              </Box>
              <img width={'100%'} src="/images/ltv_predictions_image.webp" alt="predictions"></img>
            </Box>
            {isMobile ? (
              <Box
                sx={{
                  borderRadius: '32px',
                  background: '#28292B',
                }}
              >
                <Typography className="title">Cohort Analysis for ROAS and Conversions</Typography>
                <Typography className="subTitle">
                  The system offers in-depth cohort analysis, providing insights into key performance metrics like
                  Return on Ad Spend (ROAS), revenue, conversions, and customer behavior over time, helping businesses
                  refine their strategies based on granular data.
                </Typography>
              </Box>
            ) : (
              <Box
                sx={{
                  borderRadius: '32px',
                  background: '#28292B',
                }}
              >
                <Typography className="title">Integration with Major Advertising Networks</Typography>
                <Typography className="subTitle">
                  Seamless integration with leading advertising networks, such as Google Ads, Facebook Ads, and others,
                  enables businesses to efficiently manage campaigns and track performance directly from the platform.
                </Typography>
              </Box>
            )}
          </Box>
          <Box
            sx={{
              display: 'flex',
              width: '100%',
              flexDirection: 'column',
              gap: '30px',
            }}
          >
            {isMobile ? (
              <Box
                sx={{
                  borderRadius: '32px',
                  background: '#28292B',
                }}
              >
                <Typography className="title">Integration with Major Advertising Networks</Typography>
                <Typography className="subTitle">
                  Seamless integration with leading advertising networks, such as Google Ads, Facebook Ads, and others,
                  enables businesses to efficiently manage campaigns and track performance directly from the platform.
                </Typography>
              </Box>
            ) : (
              <Box
                sx={{
                  borderRadius: '32px',
                  background: '#28292B',
                }}
              >
                <Typography className="title">Cohort Analysis for ROAS and Conversions</Typography>
                <Typography className="subTitle">
                  The system offers in-depth cohort analysis, providing insights into key performance metrics like
                  Return on Ad Spend (ROAS), revenue, conversions, and customer behavior over time, helping businesses
                  refine their strategies based on granular data.
                </Typography>
              </Box>
            )}
            <Box
              sx={{
                flexGrow: 1,
                overflow: 'hidden',
                borderRadius: '32px',
                background: '#E4F1FF',
              }}
            >
              <Typography className="title black">User Behavior Analysis</Typography>
              <Typography className="subTitle black">
                Equipped with advanced analytics tools, the system allows businesses to monitor and analyze user
                behavior in real-time, helping to identify trends, engagement patterns, and key user segments.
              </Typography>
              <img width={'100%'} src="/images/user_behavior_analysis_image.webp" alt="behavior analysis"></img>
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            background: '#247BFE',
            borderRadius: '32px',
            overflow: 'hidden',
            display: 'flex',
            gap: '20px',
            flexDirection: isMobile ? 'column' : 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Box
            sx={{
              minWidth: isMobile ? '100%' : '360px',
              maxWidth: '560px',
              marginLeft: isMobile ? '0px' : '50px',
            }}
          >
            <Typography
              sx={{
                fontSize: isMobile ? '20px' : '40px',
                fontFamily: 'RedHat700',
                color: '#FFF',
                marginBottom: '15px',
                lineHeight: 'normal',
                margin: isMobile ? '40px 20px 15px' : undefined,
              }}
            >
              AI-Powered Insights
            </Typography>
            <Typography
              sx={{
                fontSize: isMobile ? '16px' : '20px',
                fontFamily: 'RedHat400',
                color: '#FFF',
                lineHeight: isMobile ? 'normal' : '30px',
                margin: isMobile ? '0 20px 30px' : undefined,
              }}
            >
              Utilizing a pre-trained AI model, the platform delivers intelligent insights and recommendations,
              automating processes like campaign optimization, audience targeting, and performance forecasting.
            </Typography>
          </Box>
          <img
            style={{
              maxWidth: '100%',
            }}
            width={660}
            src={isMobile ? '/images/ai_mob.webp' : '/images/ai.webp'}
            alt="data storage"
          ></img>
        </Box>
      </Box>
    </Box>
  );
}

export default KeyFeatures;
